module.exports = __webpack_public_path__ + "static/img/zncw5b.ee049a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zncw5b.jpg
// module id = 7sBD
// module chunks = 73